var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.zones)?_c('div',{staticStyle:{"border":"2px solid red"},style:({width: (_vm.mainWidth + "px"), height: (_vm.mainHeight + "px")}),attrs:{"id":"design"}},_vm._l((_vm.zones),function(item,index){return _c('div',{key:index,staticStyle:{"position":"stiky","border":"1px solid black"},style:({
        marginTop: '${item.newTop}px',
        marginRight: '${item.newRight}px',
        width: '${item.newWidth}px',
        height: '${item.newHeight}px',
      })},[_vm._v(" "+_vm._s(item.ID)+" ")])}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }